<template>
    <div class="analysisTable">
        <div class="analysisTable__header">
            <div class="analysisTable__header--icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="19" viewBox="0 0 23 19" fill="none">
                    <path
                        d="M20.1057 1V0V1ZM1 2.59214H0H1ZM1 16.1254H0H1ZM2.59214 17.7175V18.7175V17.7175ZM20.1057 17.7175V18.7175V17.7175ZM21.6979 2.59214H22.6979H21.6979ZM1.64908 2.22946C1.22894 1.87098 0.597756 1.92096 0.239279 2.3411C-0.119197 2.76123 -0.0692137 3.39242 0.350921 3.7509L1.64908 2.22946ZM10.33 10.9509L9.68083 11.7117L9.68996 11.7193L10.33 10.9509ZM12.3679 10.9509L13.0079 11.7193L13.017 11.7116L12.3679 10.9509ZM22.3469 3.7509C22.7671 3.39242 22.8171 2.76123 22.4586 2.3411C22.1001 1.92096 21.4689 1.87098 21.0488 2.22946L22.3469 3.7509ZM20.1057 0H2.59214V2H20.1057V0ZM2.59214 0C1.90466 0 1.24534 0.2731 0.759221 0.759221L2.17343 2.17343C2.28448 2.06239 2.4351 2 2.59214 2V0ZM0.759221 0.759221C0.2731 1.24534 0 1.90466 0 2.59214H2C2 2.4351 2.06239 2.28448 2.17343 2.17343L0.759221 0.759221ZM0 2.59214V16.1254H2V2.59214H0ZM0 16.1254C0 16.8128 0.273101 17.4722 0.759221 17.9583L2.17343 16.5441C2.06239 16.433 2 16.2824 2 16.1254H0ZM0.759221 17.9583C1.24534 18.4444 1.90466 18.7175 2.59214 18.7175V16.7175C2.4351 16.7175 2.28448 16.6551 2.17343 16.5441L0.759221 17.9583ZM2.59214 18.7175H20.1057V16.7175H2.59214V18.7175ZM20.1057 18.7175C20.7932 18.7175 21.4525 18.4444 21.9386 17.9583L20.5244 16.5441C20.4134 16.6551 20.2628 16.7175 20.1057 16.7175V18.7175ZM21.9386 17.9583C22.4248 17.4722 22.6979 16.8128 22.6979 16.1254H20.6979C20.6979 16.2824 20.6355 16.433 20.5244 16.5441L21.9386 17.9583ZM22.6979 16.1254V2.59214H20.6979V16.1254H22.6979ZM22.6979 2.59214C22.6979 1.90466 22.4248 1.24534 21.9386 0.759221L20.5244 2.17343C20.6355 2.28448 20.6979 2.4351 20.6979 2.59214H22.6979ZM21.9386 0.759221C21.4525 0.273099 20.7932 0 20.1057 0V2C20.2628 2 20.4134 2.06239 20.5244 2.17343L21.9386 0.759221ZM0.350921 3.7509L9.68088 11.7116L10.979 10.1902L1.64908 2.22946L0.350921 3.7509ZM9.68996 11.7193C10.1557 12.1072 10.7427 12.3197 11.3489 12.3197V10.3197C11.2105 10.3197 11.0764 10.2711 10.97 10.1825L9.68996 11.7193ZM11.3489 12.3197C11.9551 12.3197 12.5421 12.1072 13.0079 11.7193L11.7279 10.1825C11.6215 10.2711 11.4874 10.3197 11.3489 10.3197V12.3197ZM13.017 11.7116L22.3469 3.7509L21.0488 2.22946L11.7188 10.1902L13.017 11.7116Z"
                        fill="#3682F3" />
                </svg>
            </div>
            <div class="analysisTable__header--title">Email</div>
        </div>
        <div class="analysisTable__content" v-if="!isLoading">
            <div class="analysisTable__content--list">
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Domínio visto pela primeira vez</div>
                            <div class="item__container--value">{{ firstSeenDomain}}</div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Visto pela primeira vez</div>
                            <div class="item__container--value">{{ firstSeen }}</div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Descartável</div>
                            <div class="item__container--value">{{ isDisposable }}</div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Grátis</div>
                            <div class="item__container--value">{{ isFree }}</div>

                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item no-border">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Alto Risco</div>
                            <div class="item__container--value">{{ isHighRisk }}</div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="row justify-content-center p-5">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'AnalysisTableClient',
    props: {
        data: {
            type: Object,
            required: true
        },
        totalizer: {
            type: Object,
            required: false
        },
    },
    computed: {
        isLoading() {
            return this.$store.getters["getLoadingAnalysis"]
        },
        firstSeenDomain() {
            if(this.data && this.data.risk_body && this.data.risk_body.email && this.data.risk_body.email.domain && this.data.risk_body.email.domain.first_seen){
                const dateParts = this.data.risk_body.email.domain.first_seen.split('-');
                return `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
            }
            return '---';
        },
        firstSeen() {
            if(this.data && this.data.risk_body && this.data.risk_body.email && this.data.risk_body.email.first_seen){
                const dateParts = this.data.risk_body.email.first_seen.split('-');
                return `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
            }
            return '---';
        },
        isDisposable() {
            return this.data && this.data.risk_body && this.data.risk_body.email && this.data.risk_body.email.is_disposable ? 'Sim ' : 'Não';  
        },
        isFree() {
            return this.data && this.data.risk_body && this.data.risk_body.email && this.data.risk_body.email.is_free ? 'Sim ' : 'Não';  
        },
        isHighRisk() {
            return this.data && this.data.risk_body && this.data.risk_body.email && this.data.risk_body.email.is_high_risk ? 'Sim ' : 'Não';  
        },
    },
};
</script>

<style scoped lang="scss">
.analysisTable {
    width: 100%;
    margin: 20px 0px 0px 0px;

    &__header {
        padding: 0px 20px;
        display: flex;
        justify-content: flex-start;

        &--icon {
            width: 20.698px;
            height: 20.698px;
            flex-shrink: 0;
        }

        &--title {
            color: #3682F3;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-left: 14px;
        }
    }

    &__content {
        height: auto;
        width: 100%;

        hr {
            background: #E5E5E5;
        }

        &--list {
            height: auto;
            width: 100%;
            margin: 20px 0px;

            .item {
                border-bottom: solid 1px #E5E5E5;
                position: relative;

                &__container {
                    padding: 20px;

                    &--title {
                        color: #B1B1B1;
                        font-size: 0.8em;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                    }

                    &--value {
                        color: #141414;
                        font-size: 0.9em;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                        width: calc(100% - 40px);
                        overflow-x: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }

                    &--pill {
                        position: absolute;
                        right: 20px;
                        top: 30%;
                        width: auto;
                        font-size: 0.7em;
                        padding: 4px 10px;
                        font-size: 12px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                        border-radius: 50px;


                    }
                }

            }

            .no-border .item {
                border-bottom: none;
            }

        }
    }
}

.blue {
    background: rgba(54, 130, 243, 0.10);
    color: #3682F3;
}

.red {
    background: rgba(255, 95, 95, 0.10);
    color: #FF5F5F;
}
</style>